import { Tooltip } from '@mui/material';
import { cloneElement, useState, useCallback } from 'react';

interface OverflowTooltipProps {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any>;
}

export function OverflowTooltip({ title, children }: OverflowTooltipProps) {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const handleRef = useCallback((node: HTMLElement | null) => {
    if (node) {
      setIsOverflowing(node.scrollWidth > node.offsetWidth);
    }
  }, []);

  return (
    <Tooltip title={title} disableHoverListener={!isOverflowing}>
      {cloneElement(children, {
        ref: handleRef,
        style: {
          ...children.props.style,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
          maxWidth: '100%',
        },
      })}
    </Tooltip>
  );
}
